import React from "react";
import Header from "../component/header";
import "../stylesheets/projects.css";
import { BiCodeAlt } from "react-icons/bi";
import projectsdata from "./projectsData";

const Projects = () => {
  return (
    <div>
      <Header />
      <div className="container projects-intro">
        <div className="row flex-with-center mt-5">
          <div data-aos="fade-right" className="col-md-6 n-box2-p px-3 py-5">
            <div>
              <h1 className="font-bold">Projects</h1>
              <p className="font-bold">
                Here are some of my projects, take a look
              </p>
              <a className="primary-button" href="#projects-list">
                Get Started
              </a>
            </div>
          </div>

          <div className="col-md-6 position-relative">
            <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
              <path
                fill="#0F62FE"
                d="M68.5,-22.8C76.8,3.2,63.2,35.7,39.1,53C15,70.3,-19.6,72.5,-42.1,56.5C-64.6,40.5,-74.9,6.4,-65.9,-20.7C-56.9,-47.7,-28.4,-67.7,0.9,-68C30.1,-68.3,60.3,-48.8,68.5,-22.8Z"
                transform="translate(100 100)"
              />
            </svg>
            <BiCodeAlt
              color="white"
              size="180"
              className="position-absolute top-50 start-50 translate-middle"
            />
          </div>
        </div>
      </div>

      <div className="container projects-list" id="projects-list">
        <h3 className="font-bold">Here are the Projects</h3>
        <hr />
        <div className="row proj-cont">
          {projectsdata.map((project) => {
            return (
              <div className="col-md-4 proj-cont">
                <div className="position-relative project">
                  <img src={project.image} alt="project-img" />
                  <div className="project-content">
                    <h3>{project.title}</h3>
                    <hr />
                    <p>{project.description}</p>
                    <a
                      target="_blank"
                      href={project.link}
                      className="contact-button"
                    >
                      See Project
                    </a>
                    <a href={project.githup} target="_blank">
                      Source code
                    </a>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Projects;
